import { render, staticRenderFns } from "./Prize_shop_slider.vue?vue&type=template&id=0e1deb79&scoped=true"
import script from "./Prize_shop_slider.vue?vue&type=script&lang=js"
export * from "./Prize_shop_slider.vue?vue&type=script&lang=js"
import style0 from "./Prize_shop_slider.vue?vue&type=style&index=0&id=0e1deb79&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1deb79",
  null
  
)

export default component.exports